import {
  GetUserRolesDto,
  OnboardingPeriodReportDto,
  Role,
} from '@zorro/clients';
import {
  formatDateEnLocaleRange,
  parseDateISO,
} from '@zorro/shared/formatters';
import { ReactElement } from 'react';

import { EnrollmentStatusIconTooltip } from '../EnrollmentStatus/EnrollmentStatusIconTooltip';
import { EmployeeLayoutSidebarSubitemProps } from './EmployeeLayoutSidebar/EmployeeLayoutSidebarSubitem';

type MapOnboardingPeriodToEmployeePageSidebarSubitemProps = {
  onboardingPeriod: OnboardingPeriodReportDto;
  onClick: () => void;
  currentOnboardingPeriodId?: string;
};

export const mapOnboardingPeriodToEmployeeSidebarSubitem = ({
  onClick,
  onboardingPeriod,
  currentOnboardingPeriodId,
}: MapOnboardingPeriodToEmployeePageSidebarSubitemProps): EmployeeLayoutSidebarSubitemProps => {
  const {
    id,
    isSpecialEnrollment,
    enrollmentEffectiveFrom,
    enrollmentStatus,
    effectiveFrom,
    effectiveUntil,
  } = onboardingPeriod;

  const year = parseDateISO(enrollmentEffectiveFrom).year();
  const yearLabel = isSpecialEnrollment
    ? 'Special enrollment'
    : 'Open enrollment';

  return {
    id,
    onClick,
    label: `${yearLabel} ${year}`,
    isChecked: currentOnboardingPeriodId === id,
    description: formatDateEnLocaleRange(effectiveFrom, effectiveUntil),
    rightContent: (
      <EnrollmentStatusIconTooltip
        enrollmentStatus={enrollmentStatus}
        iconSize={30}
        withBackground={currentOnboardingPeriodId === id}
      />
    ) as ReactElement,
  };
};

export const getEmployeeRole = (userRoles: GetUserRolesDto): Role => {
  return userRoles.roles.includes(Role.EMPLOYER_ADMIN)
    ? Role.EMPLOYER_ADMIN
    : Role.EMPLOYEE;
};
